import {Divider, Stack} from '@mui/material';
import _ from 'lodash';
import React, { useMemo } from 'react';
import moment from 'moment';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';
import TruncatedText from '../../../components/ui/text/truncatedText';

const useStyles = makeStyles((theme) => ({
    headerDemographics: {
        backgroundColor: theme.palette.background.paperDarker,
        borderRadius: "10px",
        padding: "0.5rem 1rem",
        marginRight: 'auto'
    },
    text: {
        paddingTop: 1
    }
}));

export default function PatientDemographicsBanner({ patient }) {
    const classes = useStyles();

    const patientAge = useMemo(() => moment().diff(moment(patient.dob), 'years'), [patient?.dob]);

    const patientInfo = new Map([
        ["Born:", patient?.dob?.format("DD/MM/YYYY")],
        ["Age:", patientAge],
        ["Gender:", patient?.gender?.__description],
        ["Hos No:", patient?.hospitalNumber],
        ["NHS No:", patient?.nhsNumber],
    ]);

    return (
        <Stack
            direction='row'
            alignItems='center'
            gap={1.5}
            className={clsx(classes.headerDemographics, 'scroll-normal-white')}
        >
            <Stack direction='row' alignItems='center' gap={1}>
                <TruncatedText variant='body1' text="Name:" />
                <TruncatedText variant='subtitle1' fw={700} text={`${patient.familyName}, ${patient.firstName}`} />
            </Stack>

            {Array.from(patientInfo).map(
                ([key, value]) =>
                    (value || _.isNumber(value)) && (
                        <Stack direction='row' alignItems='center' key={key} gap={1}>
                            <Divider  orientation="vertical" flexItem/>

                            <TruncatedText
                                variant='body1'
                                text={key}
                            />

                            <TruncatedText
                                variant='subtitle1'
                                fw={700}
                                text={value}
                                className={classes.text}
                            />
                        </Stack>
                    )
            )}
        </Stack>
    );
}